module.exports = __webpack_public_path__ + "img/logo.a02e709f.png";